import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ReactComponent as MoreInfoIcon } from 'assets/images/svg/more-info-2.svg';
import { ReactComponent as PlayerIcon } from 'assets/images/svg/golf-player-icon.svg';
import { ReactComponent as StarIcon } from 'assets/images/svg/icons/star-icon.svg';
import { ReactComponent as ChevronRightIcon } from 'assets/images/svg/chevron-right.svg';

import Text from 'components/shared/ui/Text';

import siteStyle from 'utils/siteStyle';
import { CANCELLATION_POLICY, REWARDS } from 'utils/routes';
import { useScreen } from 'hooks/useDimensions';

const HereToHelp = ({ className }) => {
  const history = useHistory();
  const { isMobileScreen } = useScreen();
  const giftCardLink = {
    supremeGolf: 'https://info.supremegolf.com/supreme-golf-gift-cards/',
    barstool: 'https://store.barstoolsports.com/collections/golf',
  };

  const openExternal = (href) => {
    const a = document.createElement('a');
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
  };

  const renderHelpOption = (Icon, IconClassName, title, subtitle, href, isExternal = false) => (
    <button
      type="button"
      className="w-full py-6 px-4 flex items-center gap-4 border border-light-grey-3 rounded-2 cursor-pointer focus:outline-none md:flex-col md:items-start"
      onClick={() => (isExternal ? openExternal(href) : history.push(href))}
    >
      <div className="p-3 rounded-2 bg-primary-light-2">
        <Icon className={classnames('w-6 h-6 text-primary fill-current', IconClassName)} />
      </div>
      <div className="flex flex-col gap-1 justify-center items-start">
        <div className="flex items-center gap-1">
          <h2 className={siteStyle({
            common: 'text-4 leading-5 -tracking-0.16 text-black font-bold lg:text-5 whitespace-nowrap',
            // bt: 'font-korolav uppercase',
            foh: 'font-rajdhani',
            default: 'font-primary',
          })}
          >
            {title}
          </h2>
          <ChevronRightIcon className="w-3 h-3 text-dark fill-current" />
        </div>
        <p className="font-primary-two text-3.5 leading-5 -tracking-0.2 text-grey-3 lg:text-4">{subtitle}</p>
      </div>
    </button>
  );

  return (
    <section className={className}>
      <div className="w-full max-w-300">
        <Text variant="h3">Here to help</Text>
        <p className="pt-1 font-primary-two text-4 leading-5 -tracking-0.2 text-dark md:pt-2">Resources to keep you golfing.</p>
        <div className="mt-4 flex flex-col gap-2 md:flex-row md:gap-6">
          {renderHelpOption(MoreInfoIcon, 'rotate-180', `${isMobileScreen ? 'Cancellation policy' : 'Our cancellation policy'}`, 'Just in case plans change.', CANCELLATION_POLICY)}
          {renderHelpOption(PlayerIcon, '', 'Give the gift of golf', 'Share golf with friends.', giftCardLink[process.env.REACT_APP_NAME], true)}
          {renderHelpOption(StarIcon, '', 'Earn Rewards', 'Make the most of golfing.', REWARDS)}
        </div>
      </div>
    </section>
  );
};

HereToHelp.defaultProps = {
  className: '',
};

HereToHelp.propTypes = {
  className: PropTypes.string,
};

export default HereToHelp;
